import {Color} from '@benchling/nucleus-ui';
import React from 'react';

import {NotebookSectionColor} from 'graphql-client/__generated/graphqlGlobalTypes';
import {AccordionColor, ControlledAccordion} from 'ui-library/Accordion';

export const ALLOWED_ENTRY_TO_ACCORDION_COLOR: Record<NotebookSectionColor, AccordionColor> = {
  [NotebookSectionColor.DEFAULT]: Color.GRAY_50,
  [NotebookSectionColor.RED]: '#FDE6E6',
  [NotebookSectionColor.ORANGE]: '#FCEDCE',
  [NotebookSectionColor.YELLOW]: '#FCF7CE',
  [NotebookSectionColor.GREEN]: '#E0FDEE',
  [NotebookSectionColor.BLUE]: '#E0F4FD',
  [NotebookSectionColor.INDIGO]: '#E8EDFF',
  [NotebookSectionColor.VIOLET]: '#F5ECFD',
  [NotebookSectionColor.CONTRAST_GREY]: Color.GRAY_200,
  [NotebookSectionColor.CONTRAST_RED]: Color.RED_200,
  [NotebookSectionColor.CONTRAST_ORANGE]: Color.ORANGE_300,
  [NotebookSectionColor.CONTRAST_YELLOW]: Color.YELLOW_300,
  [NotebookSectionColor.CONTRAST_GREEN]: Color.GREEN_200,
  [NotebookSectionColor.CONTRAST_BLUE]: Color.TEAL_200,
  [NotebookSectionColor.CONTRAST_INDIGO]: Color.BLUE_150,
  [NotebookSectionColor.CONTRAST_VIOLET]: Color.PURPLE_200,
};

interface EntrySectionProps {
  header: JSX.Element;
  children: Array<JSX.Element>;
  isOpen: boolean;
  onToggle: (isOpen: boolean) => void;
  sectionColor: NotebookSectionColor;
}

export default function EntrySection({
  header,
  children,
  isOpen,
  onToggle,
  sectionColor,
}: EntrySectionProps): JSX.Element {
  return (
    <ControlledAccordion
      header={header}
      isOpen={isOpen}
      setIsOpen={onToggle}
      headerStyle="bordered"
      headerColor={ALLOWED_ENTRY_TO_ACCORDION_COLOR[sectionColor]}
    >
      <section className="entry-section">{children}</section>
    </ControlledAccordion>
  );
}
